module.exports = __webpack_public_path__ + "img/20190523193808微信截图_20190523194100.5c21cd54.png";